import loadable from '@loadable/component';

// 懒加载组件
const HosItemPriceQuery = loadable(() => import('./hosItemPriceQuery/HosItemPriceQuery'));
const ItemPriceRequestManagement = loadable(() => import('./itemPriceRequestManagement/ItemPriceRequestManagement'));
const ItemPriceRequestDetailModify = loadable(() => import('./itemPriceRequestManagement/itemPriceRequestDetailModify/ItemPriceRequestDetailModify'));
const ItemNewApplicationWithSelection = loadable(() => import('./itemNewApplicationWithSelection/ItemNewApplicationWithSelection'));
const ItemDictionaryRequestManagement = loadable(() => import('./itemDictionaryRequestManagement/ItemDictionaryRequestManagement'));

export const subRoutes = [
  {
    path: '/HosItemPriceQuery',
    component: HosItemPriceQuery
  },
  {
    path: '/ItemPriceRequestDetailModify',
    component: ItemPriceRequestDetailModify
  },
  {
    path: '/ItemPriceRequestManagement',
    component: ItemPriceRequestManagement
  },
  {
    path: '/ItemNewApplicationWithSelection',
    component: ItemNewApplicationWithSelection
  },
  {
    path: '/ItemDictionaryRequestManagement',
    component: ItemDictionaryRequestManagement
  }
];
